export const baseUrl = '/supplier-documents'
